// Stores barrel export
export {
  useCartStore,
  selectCartItems,
  selectCartTotal,
  selectCartItemsCount,
  selectIsCartOpen,
  selectPromoEligiblePrice,
  selectMinOrderEligibleTotal,
  selectHasHydrated,
  type CartItem,
} from './cart-store';

export {
  useAuthStore,
  selectUser,
  selectIsAuthenticated,
  selectIsAuthLoading,
  selectIsAuthModalOpen,
  selectAuthModalView,
} from './auth-store';

export {
  useAddressStore,
  selectSelectedAddress,
  selectSelectedCity,
  selectIsAddressSheetOpen,
  selectDeliveryCost,
  selectMinOrderSum,
  selectIsInDeliveryZone,
  selectAddressHasHydrated,
  type SelectedAddress,
} from './address-store';

export {
  useCheckoutStore,
  selectCurrentStep,
  selectCurrentStepIndex,
  selectIsCheckoutOpen,
  selectStepProgress,
  selectIsFirstStep,
  selectIsLastStep,
  selectContact,
  selectDeliveryDetails,
  selectDeliveryTime,
  selectPreferences,
  selectBonusState,
  selectExtras,
  selectExtrasTotal,
  selectIsSubmitting,
  CHECKOUT_STEPS,
  STEP_TITLES,
  type CheckoutStep,
  type DeliveryTimeType,
  type OrderContact,
  type DeliveryDetails,
  type DeliveryTime,
  type OrderPreferences,
  type BonusState,
  type ExtraItem,
} from './checkout-store';

export {
  useProductPopupStore,
  selectIsPopupOpen,
  selectCurrentProduct,
  selectViewStack,
  selectIsViewingNested,
  selectOriginalProduct,
  selectSetIngredients,
  selectIsLoadingIngredients,
  selectQuantity,
} from './product-popup-store';